import DataTable from "./DataTable/DataTable";
import { Dropdown, Modal } from "react-bootstrap";

import Loader from "../../../hooks/loader";
import useUserManagement from "../../../hooks/userManagement/useUserManagement";
const UserManagementSetting = () => {
    const {
        show,
        show1,
        name,
        email,
        adminAccess,
        users,
        loading,
        pagination,
        setName,
        setEmail,
        setAdminAccess,
        handleClose,
        handleShow,
        handleClose1,
        handleShow1,
        fetchUsers,
        addUser,
        toggleUserStatus,
        isAddUserDisabled,
        setPagination
    } = useUserManagement();

    return (
        <>
            {loading && <Loader />}
            <section className="salesround">
                <div className="custom-container">
                    <div className="main-heading">
                        <div>
                            <p className="selfhead">ADMIN Settings</p>
                            <h6>User Management</h6>
                        </div>
                        <button className="btn-savechanges" onClick={handleShow}>Add User</button>
                    </div>
                    <DataTable
                        users={users}
                        toggleUserStatus={toggleUserStatus}
                        pagination={pagination}
                        onPageChange={(page) => fetchUsers(page, pagination.limit)}
                    />
                </div>
            </section>

            {/* Add User Modal */}
            <Modal
                className="add-mega-modal global-modal-scss"
                show={show}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="add-mega-div">
                        <div className="option-field">
                            <div className="material-textfield">
                                <input
                                    type="text"
                                    placeholder="Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                        </div>
                        <div style={{ position: "unset" }} className="text-danger mb-4">

                        </div>
                        <div className="option-field">
                            <div className="material-textfield">
                                <input
                                    type="text"
                                    placeholder="User Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                        </div>
                        <div style={{ position: "unset" }} className="text-danger mb-4">
                        </div>
                        <div className="option-field">
                            <Dropdown>
                                <Dropdown.Toggle
                                    variant="success"
                                    id="dropdown-basic"
                                    className="mybtnsforinput"
                                >
                                    {adminAccess ? (adminAccess === "READ" ? "Read Only" : "Read & Write") : "Select Access Level"}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="15"
                                        height="8"
                                        viewBox="0 0 15 8"
                                        fill="none"
                                    >
                                        <path
                                            d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
                                            fill="#fff"
                                        />
                                        <path
                                            d="M15 0.500244L15 3.47081L7.76667 7.50024L7.76667 4.52968L15 0.500244Z"
                                            fill="#fff"
                                        />
                                    </svg>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="menu-my" style={{ height: "auto" }}>
                                    <li>
                                        <Dropdown.Item eventKey="READ" onClick={() => setAdminAccess("READ")}>
                                            Read Only
                                        </Dropdown.Item>
                                    </li>
                                    <li>
                                        <Dropdown.Item eventKey="WRITE" onClick={() => setAdminAccess("WRITE")}>
                                            Read & Write
                                        </Dropdown.Item>
                                    </li>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div style={{ position: "unset" }} className="text-danger mb-4">
                        </div>
                    </div>
                    <div className="twice-btn">
                        <button onClick={handleClose} className="btn-cancel">
                            Cancel
                        </button>
                        <button
                            className={isAddUserDisabled ? 'disableed btn-add' : 'btn-add'}
                            onClick={addUser}
                            disabled={isAddUserDisabled}
                        >
                            {loading ? "Adding..." : "Add User"}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Success Modal */}
            <Modal
                className="connectwallet-modal buy-modal"
                show={show1}
                onHide={handleClose1}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="buy-modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="81" height="80" viewBox="0 0 81 80" fill="none">
                            <path d="M40.4997 77.8945C61.4284 77.8945 78.3945 60.9284 78.3945 39.9997C78.3945 19.071 61.4284 2.10498 40.4997 2.10498C19.571 2.10498 2.60498 19.071 2.60498 39.9997C2.60498 60.9284 19.571 77.8945 40.4997 77.8945Z" fill="#329879" />
                            <path d="M36.6264 54.4C36.0791 54.4 35.5317 54.1894 35.1528 53.7684L23.4475 42.0631C22.6054 41.221 22.6054 39.9157 23.4475 39.0736C24.2896 38.2315 25.5949 38.2315 26.437 39.0736L36.5001 49.1368L54.5212 26.4C55.237 25.4736 56.5843 25.3473 57.4685 26.0631C58.3949 26.7789 58.5212 28.1263 57.8054 29.0105L38.3107 53.6C37.9317 54.0631 37.3843 54.3579 36.7949 54.4C36.7107 54.4 36.6686 54.4 36.6264 54.4Z" fill="#E2E9EC" />
                        </svg>
                        <h6 style={{ marginTop: "11px" }}>User Successfully Added!</h6>
                        <p>An email has been sent to the user. They will be able to set their password and login to the admin panel using their new password.</p>
                        <button onClick={handleClose1} className="btn-common">
                            Okay
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default UserManagementSetting;
// import React, { useState, useEffect } from "react";
// import DataTable from "./DataTable/DataTable";
// import { Dropdown, Modal } from "react-bootstrap";
// import { Api_Url } from "../../../utils/ApiUrl";
// import axios from "axios";
// import { toast } from "react-toastify";
// import Loader from "../../../hooks/loader";

// const UserManagementSetting = () => {
//     // State for controlling modal visibility
//     const [show, setShow] = useState(false);
//     const [show1, setShow1] = useState(false);
//     const [name, setName] = useState("");
//     const [email, setEmail] = useState("");
//     const [adminAccess, setAdminAccess] = useState(""); // Changed default to empty string
//     const [users, setUsers] = useState([]);

//     const [loading, setLoading] = useState(false);
//     const [pagination, setPagination] = useState({
//         currentPage: 1,
//         totalPages: 1,
//         totalCount: 0,
//         limit: 10
//     });
    
//     let Apiurl = Api_Url;
//     let accessToken = localStorage.getItem("accessToken");

//     // Functions to handle modal open/close
//     const handleClose = () => {
//         setShow(false);
//         // Reset form fields
//         setName("");
//         setEmail("");
//         setAdminAccess("READ");
//     };

//     const handleShow = () => setShow(true);
//     const handleClose1 = () => setShow1(false);
//     const handleShow1 = () => setShow1(true);

//     // Function to fetch user listing
//     const fetchUsers = async (page = 1, limit = 10, orderDirection = -1, orderField = "createdAt") => {
//         try {
//             setLoading(true);
//             const response = await axios.get(
//                 `${Apiurl}/users/get/admin?offset=${page}&limit=${limit}&orderDirection=${orderDirection}&orderField=${orderField}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${accessToken}`
//                     }
//                 }
//             );

//             if (response.data.statusCode === 200) {
//                 setUsers(response.data.data.admins);
//                 setPagination({
//                     currentPage: page,
//                     totalPages: response.data.data.pages,
//                     totalCount: response.data.data.count,
//                     limit
//                 });
//             } else {
//                 toast.error("Failed to fetch users");
//             }
//         } catch (error) {
//             console.error("Error fetching users:", error);
//             toast.error(error.response?.data?.message || "Something went wrong while fetching users");
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Add user function
//     const addUser = async () => {
//         // Validate inputs
//         if (!name.trim()) {
//             toast.error("Name is required");
//             return;
//         }

//         if (!email.trim()) {
//             toast.error("Email is required");
//             return;
//         }

//         // Simple email validation
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailRegex.test(email)) {
//             toast.error("Please enter a valid email address");
//             return;
//         }

//         try {
//             setLoading(true);
//             const response = await axios.post(
//                 `${Apiurl}/users/create/admin`,
//                 {
//                     name,
//                     email,
//                     adminAccess
//                 },
//                 {
//                     headers: {
//                         Authorization: `Bearer ${accessToken}`,
//                         "Content-Type": "application/json"
//                     }
//                 }
//             );

//             if (response.data.statusCode === 201) {
//                 handleClose(); // Close the add user modal
//                 handleShow1(); // Show success modal
//                 fetchUsers(pagination.currentPage, pagination.limit); // Refresh user list
//                 toast.success("User added successfully");
//             } else {
//                 toast.error(response.data.message || "Failed to add user");
//             }
//         } catch (error) {
//             console.error("Error adding user:", error);
//             toast.error(error.response?.data?.message || "Something went wrong while adding user");
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Toggle user active status
//     const toggleUserStatus = async (userId) => {
        
    
//         try {
//             setLoading(true);
//             // await checkAdminPermission();
            
//             const response = await axios.patch(
//                 `${Apiurl}/users/toggle/admin`,
//                 {
//                     id: userId
//                 },
//                 {
//                     headers: {
//                         Authorization: `Bearer ${accessToken}`,
//                         "Content-Type": "application/json"
//                     }
//                 }
//             );

//             if (response.data.statusCode === 201) {
//                 fetchUsers(pagination.currentPage, pagination.limit); // Refresh user list
//                 toast.success("User status updated successfully");
//             } else {
//                 toast.error(response.data.message || "Failed to update user status");
//             }
//         } catch (error) {
//             console.error("Error toggling user status:", error);
//             toast.error(error.response?.data?.message || "Something went wrong while updating user status");
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Fetch users on component mount
//     useEffect(() => {
//         fetchUsers();
//     }, []);
//     const isAddUserDisabled = !name.trim() || !email.trim() || !adminAccess || loading;

//     return (
//         <>
//             {loading && <Loader/>}
//             <section className="salesround">
//                 <div className="custom-container">
//                     <div className="main-heading">
//                         <div>
//                             <p className="selfhead">ADMIN Settings</p>
//                             <h6>User Management</h6>
//                         </div>
//                         <button className="btn-savechanges" onClick={handleShow}>Add User</button>
//                     </div>
//                     <DataTable
//                         users={users}
//                         toggleUserStatus={toggleUserStatus}
//                         pagination={pagination}
//                         onPageChange={(page) => fetchUsers(page, pagination.limit)}
//                     />
//                 </div>
//             </section>

//             {/* Add User Modal */}
//             <Modal
//                 className="add-mega-modal global-modal-scss"
//                 show={show}
//                 onHide={handleClose}
//                 centered
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Add User</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="add-mega-div">
//                         <div className="option-field">
//                             <div className="material-textfield">
//                                 <input
//                                     type="text"
//                                     placeholder="Name"
//                                     value={name}
//                                     onChange={(e) => setName(e.target.value)}
//                                 />
//                             </div>
//                         </div>
//                         <div style={{ position: "unset" }} className="text-danger mb-4">

//                         </div>
//                         <div className="option-field">
//                             <div className="material-textfield">
//                                 <input
//                                     type="text"
//                                     placeholder="User Email"
//                                     value={email}
//                                     onChange={(e) => setEmail(e.target.value)}
//                                 />
//                             </div>
//                         </div>
//                         <div style={{ position: "unset" }} className="text-danger mb-4">
//                         </div>
//                         <div className="option-field">
//                             <Dropdown>
//                                 <Dropdown.Toggle
//                                     variant="success"
//                                     id="dropdown-basic"
//                                     className="mybtnsforinput"
//                                 >
//                                     {adminAccess ? (adminAccess === "READ" ? "Read Only" : "Read & Write") : "Select Access Level"} {/* Changed default text */}
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="15"
//                                         height="8"
//                                         viewBox="0 0 15 8"
//                                         fill="none"
//                                     >
//                                         <path
//                                             d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M15 0.500244L15 3.47081L7.76667 7.50024L7.76667 4.52968L15 0.500244Z"
//                                             fill="black"
//                                         />
//                                     </svg>
//                                 </Dropdown.Toggle>
//                                 <Dropdown.Menu className="menu-my" style={{ height: "auto" }}>
//                                     <li>
//                                         <Dropdown.Item eventKey="READ" onClick={() => setAdminAccess("READ")}>
//                                             Read Only
//                                         </Dropdown.Item>
//                                     </li>
//                                     <li>
//                                         <Dropdown.Item eventKey="WRITE" onClick={() => setAdminAccess("WRITE")}>
//                                             Read & Write
//                                         </Dropdown.Item>
//                                     </li>
//                                 </Dropdown.Menu>
//                             </Dropdown>
//                         </div>
//                         <div style={{ position: "unset" }} className="text-danger mb-4">
//                         </div>
//                     </div>
//                     <div className="twice-btn">
//                         <button onClick={handleClose} className="btn-cancel">
//                             Cancel
//                         </button>
//                         <button
//                             className={isAddUserDisabled ? 'disableed btn-add' : 'btn-add'}
//                             onClick={addUser}
//                             disabled={isAddUserDisabled}
//                         >
//                             {loading ? "Adding..." : "Add User"}
//                         </button>
//                     </div>
//                 </Modal.Body>
//             </Modal>

//             {/* Success Modal */}
//             <Modal
//                 className="connectwallet-modal buy-modal"
//                 show={show1}
//                 onHide={handleClose1}
//                 centered
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Success</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="buy-modal">
//                         <svg xmlns="http://www.w3.org/2000/svg" width="81" height="80" viewBox="0 0 81 80" fill="none">
//                             <path d="M40.4997 77.8945C61.4284 77.8945 78.3945 60.9284 78.3945 39.9997C78.3945 19.071 61.4284 2.10498 40.4997 2.10498C19.571 2.10498 2.60498 19.071 2.60498 39.9997C2.60498 60.9284 19.571 77.8945 40.4997 77.8945Z" fill="#329879" />
//                             <path d="M36.6264 54.4C36.0791 54.4 35.5317 54.1894 35.1528 53.7684L23.4475 42.0631C22.6054 41.221 22.6054 39.9157 23.4475 39.0736C24.2896 38.2315 25.5949 38.2315 26.437 39.0736L36.5001 49.1368L54.5212 26.4C55.237 25.4736 56.5843 25.3473 57.4685 26.0631C58.3949 26.7789 58.5212 28.1263 57.8054 29.0105L38.3107 53.6C37.9317 54.0631 37.3843 54.3579 36.7949 54.4C36.7107 54.4 36.6686 54.4 36.6264 54.4Z" fill="#E2E9EC" />
//                         </svg>
//                         <h6 style={{ marginTop: "11px" }}>User Successfully Added!</h6>
//                         <p>An email has been sent to the user. They will be able to set their password and login to the admin panel using their new password.</p>
//                         <button onClick={handleClose1} className="btn-common">
//                             Okay
//                         </button>
//                     </div>
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

// export default UserManagementSetting;
